/**
 * Origen de la solicitud del enlace magico. El `data` viene del primer correo;
 * el `access` es un token ya vencido, que sigue sirviendo para pedir uno nuevo
 * cuando el empleado llego por el enlace magico y no tiene el `data` a mano.
 */
export type ShareAccessRequest = { data: string } | { access: string }

/* Respuesta de solicitar el enlace de acceso (POST public/documents/shares/request-access) */
export interface RequestShareAccessResponse {
  sent: boolean
  /* Espera minima antes de poder pedir otro enlace */
  retryAfterSeconds: number
  /* Vigencia del enlace recien enviado */
  expiresInSeconds: number
}

/**
 * Respuesta al canjear el token magico (POST public/documents/shares/access).
 *
 * El estado de aprobacion viaja en cada acceso para que sobreviva a un refresco:
 * la vista no puede recordarlo por su cuenta.
 */
export interface ShareAccessResponse {
  downloadUrl: string
  /* La nomina permite que el empleado apruebe (payrolls.send_approval) */
  approvalEnabled: boolean
  approved: boolean
  approvedAt: string | null
}

/* Decision del empleado sobre su desprendible */
export type ShareDecision = 'APPROVE' | 'REJECT'

/* Respuesta al aprobar o rechazar (POST public/documents/shares/decision) */
export interface ShareDecisionResponse {
  status: string
}

/* Codigos de error que devuelven los endpoints publicos de shares */
export type ShareErrorCode =
  | 'INVALID_SHARE_LINK'
  | 'INVALID_ACCESS_TOKEN'
  | 'ACCESS_TOKEN_EXPIRED'
  | 'ShareAccessRequestTooSoon'
  | 'DocumentShareNotFound'
  | 'DocumentShareNotAccessible'
  | 'InvalidShareApprovalTransition'
  | 'UNKNOWN'

/* Error de los endpoints publicos, ya traducido a un codigo que la vista entiende */
export class ShareRequestError extends Error {
  constructor(
    public readonly code: ShareErrorCode,
    /* Solo en ShareAccessRequestTooSoon: cuanto falta para poder reintentar */
    public readonly retryAfterSeconds?: number
  ) {
    super(code)
    this.name = 'ShareRequestError'
  }
}
